import { render, staticRenderFns } from "./SidebarV2.vue?vue&type=template&id=55588917&"
import script from "./SidebarV2.vue?vue&type=script&lang=js&"
export * from "./SidebarV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidebarV2.vue"
export default component.exports